import type { PreviewTarget } from "@/features/preview/preview-panel";
import { SECTION } from "./survey-sections";

/** Where the preview goes for a section (redesign spec §6): a step shows
 *  that step (the draft "New step" is appended last); Thank you shows the
 *  closing screen; General, Appearance and Header show step 1. Placements and the
 *  danger zone don't move it. */
export function previewTargetFor(sectionId: string, stepIds: string[]): PreviewTarget | null {
    if (sectionId === SECTION.newStep) return stepIds.length;
    const stepPrefix = SECTION.step("");
    if (sectionId.startsWith(stepPrefix)) {
        const index = stepIds.indexOf(sectionId.slice(stepPrefix.length));
        return index >= 0 ? index : null;
    }
    if (sectionId === SECTION.thanks) return "thanks";
    if (
        sectionId === SECTION.general ||
        sectionId === SECTION.appearance ||
        sectionId === SECTION.header ||
        sectionId === SECTION.steps
    )
        return 0;
    return null;
}
